import { Button } from "@package/subframe/components/Button";
import { FeatherEdit2 } from "@subframe/core";
import type { Ref } from "react";

/** `section` names the button for screen readers, which otherwise hear eight "Edit"s. */
export function ProfileSectionEditButton({
  section,
  onClick,
  ref,
}: {
  section: string;
  onClick: () => void;
  ref?: Ref<HTMLButtonElement>;
}) {
  return (
    <Button
      ref={ref}
      aria-label={`Edit ${section}`}
      variant="neutral-secondary"
      size="small"
      icon={<FeatherEdit2 />}
      onClick={onClick}
    >
      Edit
    </Button>
  );
}
